import { motion } from "motion/react"
import { IconOffice3Outline18 as BuildingIcon } from "nucleo-ui-outline-18"
import Balancer from "react-wrap-balancer"
import { z } from "zod"

import { Button, Form, FormInput, useZodForm } from "@productlane/ui"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

const EditWorkspaceNameSchema = z.object({
	name: z.string().min(1),
})

export function EditWorkspaceNameSlide({
	nextSlide,
}: {
	nextSlide: () => void
}) {
	const ctx = api.useUtils()
	const workspaceInfo = api.workspace.info.useQuery()

	const updateWorkspaceMutation = api.workspace.update.useMutation({
		onSuccess: async () => {
			await ctx.workspace.info.invalidate()
			nextSlide()
		},
		onError: (error) => {
			toast.error({
				title: "Couldn't update workspace.",
				description: error.message,
			})
		},
	})

	const form = useZodForm({
		schema: EditWorkspaceNameSchema,
		values: { name: workspaceInfo.data?.name ?? "" },
	})

	return (
		<motion.div className="flex w-full flex-col items-center">
			<div className="mb-2 w-full text-left text-3xl font-bold">
				Name your workspace
			</div>
			<Balancer className="mr-auto w-full text-sm text-secondary">
				We prefilled this from your Linear organization - feel free to change
				it.
			</Balancer>
			<div className="mt-8 flex w-full items-center justify-center gap-10">
				<Form
					className="w-full space-y-8"
					id="edit-workspace-name-form"
					form={form}
					onSubmit={(values) => {
						updateWorkspaceMutation.mutate({ name: values.name })
					}}
				>
					<div className="max-w-xx mx-auto px-0.5">
						<FormInput
							showErrorMessage={false}
							icon={BuildingIcon}
							placeholder="Acme"
							name="name"
							type="text"
							label="Workspace name"
							inputClassName="h-10 w-full"
							autoFocus
						/>
					</div>

					<div className="flex w-full justify-center">
						<Button
							form="edit-workspace-name-form"
							type="submit"
							size="xl"
							className="max-w-xss w-full"
							isLoading={
								updateWorkspaceMutation.isLoading || workspaceInfo.isLoading
							}
						>
							Continue
						</Button>
					</div>
				</Form>
			</div>
		</motion.div>
	)
}
